import { useState, useRef } from 'react';
import { handleSkillGroup, getSkillList } from '@/utils/Page';
import { defaultSkill } from '@/utils/Page/constant';
const isUaualSkillAvailable = (skillList) => {
    let res = skillList.find((skill) => skill.left_side === 1 && String(skill.ability_id) === '-1');

    return res;
};
const useSkill = (props) => {
    const { searchParams, side, skillStore } = props;
    const [skillList, setSkillList] = useState({ apartList: [], unApartList: [] });
    const [curSkill, changeCurSkill] = useState({});
    const curSkillRef = useRef([]); //当前技能
    const skillListRef = useRef([]); //技能列表--未处理
    const [curPlugin, changePlugin] = useState([]);
    const curpluginRef = useRef([]);
    const [skillPreQuestion, setSkillPrequesion] = useState([]); //技能的预设问题
    //设置插件
    const setCurPlugin = (plugin) => {
        changePlugin(plugin);
        curpluginRef.current = plugin;
    };
    //设置技能    //切换技能时重置插件
    const setCurSkill = (targetSkill) => {
        setCurPlugin([]);
        let resultSkill = {};
        //如果传入的targetSkill不为空，判断是否存在该技能
        if (targetSkill?.ability_id) {
            let skill = skillListRef.current.find((ele) => {
                return String(ele.ability_id) === String(targetSkill?.ability_id);
            });

            //技能不存在 或者不显示
            if (!skill || skill.left_side === 0) {
                skillStore.setSkillAvailable(false);
            } else if (skill?.left_side === 2) {
                //对话框上方的技能
                if (isUaualSkillAvailable(skillListRef.current)) {
                    skillStore.setSkillAvailable(true);
                } else {
                    skillStore.setSkillAvailable(false);
                }
            } else {
                skillStore.setSkillAvailable(true);
            }

            resultSkill = {
                ...targetSkill,
                ...skill
            };
        } else {
            //传入的是{}，开启新会话
            skillStore.setSkillAvailable(true);
        }

        changeCurSkill(resultSkill);
        curSkillRef.current = resultSkill;
        if (resultSkill?.pre_question_json) {
            setSkillPrequesion(resultSkill?.pre_question_json || []);
        } else {
            setSkillPrequesion([]);
        }
    };
    //切换会话的时候处理技能
    const handleSkillAtChangeSession = (session) => {
        let skill = skillList?.apartList.find((item) => item.ability_id === session?.skill_id);
        // 如果在隔离技能中没找到，再从非隔离技能列表中查找
        if (!skill) {
            skill = skillList?.unApartList.find((item) => item.ability_id === session?.skill_id);
        }
        if (!skill) {
            skill = defaultSkill;
        }
        setCurSkill(skill);
    };
    //获取技能列表--处理成隔离及未隔离分组
    const getGroupSkillList = (scene_setting, scene_id, toolList = [], isLogin = false) => {
        let res = getSkillList(scene_setting, scene_id, isLogin);
        let urlSkillId = searchParams.get('skill_id');

        skillListRef.current = res;
        let { apartList = [], unApartList = [] } = handleSkillGroup(res, toolList, side);
        let nextCurSkill = null;
        if (apartList.length > 0) {
            nextCurSkill = apartList[0];
        }
        if (urlSkillId) {
            let urlSkillInfo = res.find((item) => item.ability_id === urlSkillId);
            if (urlSkillInfo) {
                nextCurSkill = urlSkillInfo;
            }
        }
        if (nextCurSkill) {
            setCurSkill(nextCurSkill);
        }
        setSkillList({
            apartList,
            unApartList
        });
    };
    const getTargetSkill = (skillId) => {
        let temSkill = skillListRef.current.find((ele) => ele.ability_id === skillId);
        return temSkill;
    };
    return {
        curPlugin,
        setCurPlugin,
        curpluginRef,
        curSkill,
        curSkillRef,
        setCurSkill,
        skillList,
        setSkillList,
        skillListRef,
        getTargetSkill,
        handleSkillAtChangeSession,
        getGroupSkillList,
        skillPreQuestion,
        setSkillPrequesion
    };
}; //返回当前技能
export default useSkill;
